// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_satisfaction_report-layout {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px; }\n  .modal_satisfaction_report-layout .container-form-satisfaction {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    align-items: center; }\n  .modal_satisfaction_report-layout .container-actions-satisfaction {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px; }\n", ""]);
// Exports
module.exports = exports;
